import { Form, InputNumber, Table } from "antd";
import React from "react";

export default function Result({ questions }) {
  return (
    <Table
      columns={[
        {
          title: "Análisis",
          dataIndex: "name",
        },
        {
          title: "Resultados",
          key: "input",
          render: (text, question) => (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Form.Item
                style={{ marginBottom: 0 }}
                name={question.id}
              >
                <InputNumber step={0.1} />
              </Form.Item>
              <span style={{ marginLeft: 10 }}>{question.unit.code}</span>
            </div>
          ),
        },
        {
          title: "Rango de Referencia",
          dataIndex: "range",
        },
      ]}
      dataSource={questions}
      pagination={false}
      rowKey="id"
    />
  );
}
